import { create } from "zustand";

type FinishingType = {
    finishing: string | null;
    setFinishing: (finishing: string | null) => void;
};

export const useFinishing = create<FinishingType>()((set) => ({
    finishing: null,
    setFinishing: (finishing: string | null) =>
        set(() => {
            return { finishing: finishing };
        }),
}));
